import React from "react";

interface ReviewSectionProps {
  title: string;
  children: React.ReactNode;
}

export function ReviewSection({ title, children }: ReviewSectionProps) {
  return (
    <div className="mb-6">
      <h3 className="text-sm font-semibold text-secondary-foreground mb-2">{title}</h3>
      <div className="bg-card rounded-lg px-4 divide-y divide-border">{children}</div>
    </div>
  );
}
